import axios from 'axios';
import language from '@/views/talkytimes/views/message/utils/language';

function resolveLangCode(code) {
  if (!code || code === 'auto') return '';
  return code.split('-')[0];
}

function buildTranslationPrompt(text, targetName) {
  return `Translate to ${targetName}. Only output the translation:\n${String(text)}`;
}

function normalizeTranslation(text, targetName) {
  if (!text) return '';
  let result = String(text).trim();

  const targetMarker = `${targetName}:`;
  if (result.startsWith(targetMarker)) {
    result = result.slice(targetMarker.length).trim();
  }

  return result.trim().replace(/^["'「『]|["'」』]$/g, '');
}

function isValidTranslation(result, sourceText, targetCode) {
  const trimmed = result.trim();
  const source = String(sourceText).trim();
  if (!trimmed) return false;

  const code = resolveLangCode(targetCode) || 'zh';
  if (code === 'zh') {
    return /[\u4e00-\u9fa5]/.test(trimmed);
  }
  if (code === 'en') {
    return /[a-zA-Z]/.test(trimmed) && trimmed !== source;
  }
  return trimmed !== source;
}

/**
 * 通过 LM Studio OpenAI 兼容 chat/completions 接口进行翻译（关闭推理）
 */
export function lmStudioTranslate(text, from = 'auto', to = 'zh') {
  if (!text || !String(text).trim()) {
    return Promise.resolve('');
  }

  const targetCode = resolveLangCode(to) || 'zh';
  const targetName = language.getLangEnglishNameByCode(targetCode);

  return axios
    .post(
      '/lm-studio-api/v1/chat/completions',
      {
        model: 'Qwythos-9B',
        messages: [
          {
            role: 'user',
            content: buildTranslationPrompt(text, targetName),
          },
        ],
        stream: false,
        reasoning_format: 'auto',
        chat_template_kwargs: {
          enable_thinking: false,
        },
        thinking_budget_tokens: -1,
        reasoning_control: false,
        max_tokens: 256,
        temperature: 0,
      },
      {
        headers: { 'Content-Type': 'application/json' },
        timeout: 120000,
      }
    )
    .then((response) => {
      const choice = response.data?.choices?.[0];
      const content = choice?.text ?? choice?.message?.content;
      if (!content) {
        throw new Error('LM Studio 返回结果为空');
      }
      const result = normalizeTranslation(content, targetName);
      if (!isValidTranslation(result, text, targetCode)) {
        throw new Error('翻译结果无效，模型未返回目标语言内容');
      }
      return result;
    });
}
